import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { show: Boolean };

  connect() {
    if (this.showValue) {
      this.open();
    }
  }

  open() {
    this.element.showModal(); // Opens the <dialog> element as a modal
  }

  hide() {
    this.element.close(); // Closes the <dialog> element
  }
}
